<template>
      <router-view></router-view>
</template>

<script>

export default {
    name :'MyDoveDirectoryPage',
   
}
</script>

<style lang="scss" scoped>

.saved {
    .saved-title {
      font-weight: 700;
      font-size: 24px;
      line-height: 32px;
      color: #0f1734;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/home/MyDoveDirectoryPage.vue